import { startLoading } from 'store/actions/commons/startLoading';
import { endLoading } from 'store/actions/commons/endLoading';

export const commons = {
  startLoading,
  endLoading,
};
